var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.onClick && _vm.onClick()}}},[_c('i',{class:_vm.iconClass}),_c('span',{domProps:{"textContent":_vm._s(_vm.children)}})])}
var staticRenderFns = []

export { render, staticRenderFns }